import { LinearProgress as LinearProgressUI } from "@evergis/ui";
import styled from "styled-components";

export const Content = styled.div<{ confirmOnly?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${({ confirmOnly }) => (confirmOnly ? "0" : "1.25rem")};
`;

export const LoadingDescription = styled.div`
  color: ${({ theme: { palette } }) => palette.textSecondary};
  margin: 1.5rem 0 0.25rem;
`;

export const ConfirmText = styled(LoadingDescription)`
  font: ${({ theme: { fonts } }) => fonts.description};
  margin: 0 0 1.5rem;
  white-space: pre-line;
`;

export const LinearProgress = styled(LinearProgressUI)`
  margin-top: 0.875rem;
`;
